<template>
  <section>
    <h1>{{ t('app.not_found_title') }}</h1>
    <p>{{ t('app.not_found_text') }}</p>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
